var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 13.95 4.05 18 9 18C13.95 18 18 13.95 18 9C18 4.05 13.95 0 9 0C4.05 0 0 4.05 0 9ZM1.125 9C1.125 4.6125 4.6125 1.125 9 1.125C13.3875 1.125 16.875 4.725 16.875 9C16.875 13.275 13.275 16.875 9 16.875C4.725 16.875 1.125 13.3875 1.125 9Z",
    fill: "#E64B38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25C8.6625 11.25 8.4375 11.025 8.4375 10.6875V4.61255C8.4375 4.27505 8.6625 4.05005 9 4.05005C9.3375 4.05005 9.5625 4.27505 9.5625 4.61255V10.6875C9.5625 11.025 9.3375 11.25 9 11.25Z",
    fill: "#E64B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00039 14.0624C8.77539 14.0624 8.55039 13.9499 8.43789 13.8374C8.32539 13.7249 8.21289 13.4999 8.21289 13.2749C8.21289 13.1624 8.21289 13.0499 8.21289 12.9374C8.21289 12.8249 8.32539 12.7124 8.32539 12.7124C8.55039 12.4874 8.88789 12.3749 9.11289 12.5999C9.22539 12.5999 9.33789 12.7124 9.33789 12.7124C9.45039 12.8249 9.45039 12.8249 9.45039 12.9374C9.45039 13.0499 9.45039 13.1624 9.45039 13.2749C9.45039 13.3874 9.45039 13.4999 9.45039 13.6124C9.45039 13.7249 9.33789 13.7249 9.33789 13.8374C9.45039 14.0624 9.22539 14.0624 9.00039 14.0624Z",
    fill: "#E64B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.72a28f755a8dc41702175e0fc75b927b.svg";
export { ForwardRef as ReactComponent };